<p class="title">Vincular respuesta deudor</p>

<div *ngFor="let email of emails; let i = index" class="drawer">
  <div class="drawer__header">
    <img
      class="drawer__icon"
      (click)="toggleDrawer(i)"
      [ngClass]="{ 'rotate-down': openStates.has(i) }"
      class="drawer__icon"
      src="../../../../assets/icons/filled-arrow.svg"
    />
    <lib-text
      size="xs"
      weight="medium"
      class="drawer__subject"
      [content]="email.replies[0].subject"
    >
    </lib-text>
    <img
      class="drawer__delete-btn"
      (click)="openPopup(email)"
      src="../../../../assets/icons/empty-trash.svg"
    />
  </div>

  <div
    class="drawer__content"
    [@drawerAnimation]="openStates.has(i)"
    [hidden]="!openStates.has(i)"
  >
    <div *ngFor="let reply of email.replies; let i = index">
      <div class="button__container">
        <fs-ui-button
          *ngIf="i !== 0"
          (click)="submit(reply.emailId, email.emailId)"
          class="button"
          [label]="'Vincular'"
        ></fs-ui-button>
      </div>
      <div class="drawer__email">
        <app-email-preview-html [html]="reply.body"></app-email-preview-html>
      </div>
    </div>
  </div>
</div>

<p *ngIf="!emails?.length" class="text-empty">
  No hay nuevos correos por revisar
</p>
